export const formatCurrency = (value) => {
  const number = Number(value ?? 0);
  const safe = Number.isFinite(number) ? number : 0;
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(safe);
};

export const formatNumber = (value) => {
  const number = Number(value ?? 0);
  const safe = Number.isFinite(number) ? number : 0;
  return new Intl.NumberFormat('fr-FR').format(safe);
};

export const formatPercent = (value, digits = 0) => {
  const number = Number(value ?? 0);
  const safe = Number.isFinite(number) ? number : 0;
  return new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(safe) + '%';
};

export const formatDate = (value, options) => {
  if (!value) return '-';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('fr-FR', options ?? {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
};

export const formatDateTime = (value, options) => {
  if (!value) return '-';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('fr-FR', options ?? {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};
